import axios from "axios";

export default function getDashboardStats(filterOnUserId) {
    return axios.get("/dashboard/getDashboardStats/" + filterOnUserId);
}
